import * as React from "react";

import { DataMutationAddToWishlistProvider } from "../../../Common";

import { useReactPdpInitialState } from "../react-pdp-initial-state-provider";

import { PdpAddToWishlistProvider } from "./pdp-add-to-wishlist-provider";
import { PdpWishlistPresentationProvider } from "./pdp-wishlist-presentation-provider";
import { PdpWishlistUserExperienceProvider } from "./pdp-wishlist-user-experience-provider";
import { PdpWishlistUserExperienceTriggersProvider } from "./pdp-wishlist-user-experience-triggers-provider";

export const PdpWishlistProvider: React.FunctionComponent = (props) => {
  return (
    <React.Fragment>
      <DataMutationAddToWishlistProvider
        useInitialState={useReactPdpInitialState}
      >
        <PdpAddToWishlistProvider>
          <PdpWishlistUserExperienceProvider>
            <PdpWishlistUserExperienceTriggersProvider>
              <PdpWishlistPresentationProvider>
                {props.children || []}
              </PdpWishlistPresentationProvider>
            </PdpWishlistUserExperienceTriggersProvider>
          </PdpWishlistUserExperienceProvider>
        </PdpAddToWishlistProvider>
      </DataMutationAddToWishlistProvider>
    </React.Fragment>
  );
};
